import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export interface ContentVersionOption {
  assetId: string;
  label: string;
}

export function ContentVersionSelect({
  value,
  options,
  onValueChange,
  disabled,
  className = 'w-20 shrink-0',
}: {
  value: string;
  options: ContentVersionOption[];
  onValueChange: (assetId: string) => void;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <Select
      value={value}
      onValueChange={onValueChange}
      disabled={disabled ?? options.length < 2}
    >
      <SelectTrigger aria-label="Content version" className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.assetId} value={option.assetId}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
